import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesRoutingModule } from './pipes-routing.module';
import { DealArrayPipe } from './deal-array/deal-array.pipe';
import { DateComparePipe } from './dateCompare/date-compare.pipe';
import { FormatPipe } from './format/format.pipe';
import { BypassSecurityTrustHtmlPipe } from './bypassSecurityTrustHtml/bypass-security-trust-html.pipe';

@NgModule({
  declarations: [DealArrayPipe, DateComparePipe, FormatPipe, BypassSecurityTrustHtmlPipe],
  imports: [CommonModule, PipesRoutingModule],
  exports: [DealArrayPipe, DateComparePipe, FormatPipe, BypassSecurityTrustHtmlPipe],
})
export class PipesModule {
}
